<template>
  <div v-if="show_chart" class="stats__chart">
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :class="chartClass"
      role="img"
    >
      <polyline
        class="stats__chart__line"
        fill="none"
        stroke-width="1"
        :attr="'width=111'"
        :points="getLinePointsCoords()"
      />
      <g class="stats__chart__data" data-setname="stats">
        <circle
          v-for="(value, stat) in statsData"
          :key="`chart-${stat}`"
          :cx="line_coords[stat].x"
          :cy="line_coords[stat].y"
          :data-value="value"
          r="4"
        />
      </g>
    </svg>
  </div>
</template>

<script>
const calculate_percent = (value, max_value) => {
  let current_percent = Math.floor((value / max_value) * 100);

  return current_percent <= 100 ? current_percent : max_value;
};

const calculate_compet_value = value => {
  // Для компета 21 это минимальный ранг,
  // а 1 это максимальный ранг
  return value === 0 || value > 21 ? 0 : 21 - --value;
};

export default {
  name: "StatsChart",

  props: {
    statsData: Object,
    statType: String,
  },

  data: function() {
    return {
      show_chart: false,
      line_coords: {},
      charts_map: {
        pvp: ["kd", "headshots", "slide", "explosive", "compet_rank"],
        event: ["daily", "common", "rewards"],
      },
      // Coords format: [x, y]
      coords: {
        // PvP
        kd: {
          min: { x: 225, y: 140 },
          max: { x: 225, y: 27 },
          max_value: 3,
        },
        headshots: {
          min: { x: 127, y: 216 },
          max: { x: 26, y: 181 },
          max_value: 100,
        },
        compet_rank: {
          min: { x: 323, y: 216 },
          max: { x: 426, y: 181 },
          max_value: 21,
        },
        slide: {
          min: { x: 163, y: 339 },
          max: { x: 103, y: 430 },
          max_value: 50,
        },
        explosive: {
          min: { x: 286, y: 339 },
          max: { x: 350, y: 430 },
          max_value: 50,
        },

        // Event
        daily: {
          min: { x: 225, y: 136 },
          max: { x: 225, y: 40 },
          max_value: 1080,
        },
        common: {
          min: { x: 114, y: 359 },
          max: { x: 30, y: 432 },
          max_value: 90,
        },
        rewards: {
          min: { x: 336, y: 359 },
          max: { x: 420, y: 432 },
          max_value: 88,
        },
      },
    };
  },

  computed: {
    chartMap() {
      return this.charts_map[this.statType];
    },

    chartClass() {
      return ["stats__chart__graph", `chart-${this.statType}`];
    },
  },

  mounted() {
    this.calculateStatsCoords();
  },

  methods: {
    calculateStatsCoords() {
      for (const stat in this.statsData) {
        if (this.statsData.hasOwnProperty(stat)) {
          const stat_value = this.statsData[stat];

          this.line_coords[stat] = this.getCoords(stat, stat_value);
        }
      }

      if (Object.keys(this.line_coords).length > 0) {
        this.show_chart = true;
      }
    },

    getLinePointsCoords() {
      const line_finish = Object.values(this.line_coords)[0];
      let coords_string = "";

      this.chartMap.forEach(element => {
        const coords = this.line_coords[element];
        coords_string += `${coords.x},${coords.y} `;
      });
      coords_string += `${line_finish.x},${line_finish.y}`;

      return coords_string;
    },

    getCoords(stat, value) {
      const stat_data = this.coords[stat];
      const stat_value = stat === "compet_rank" ? calculate_compet_value(value) : value;
      const stat_rating = calculate_percent(stat_value, stat_data.max_value);

      return {
        x: this.calculateCoords("x", stat_data, stat_rating),
        y: this.calculateCoords("y", stat_data, stat_rating),
      };
    },

    calculateCoords(type, stat_data, stat_rating) {
      return (
        Math.floor(((stat_data.max[type] - stat_data.min[type]) * stat_rating) / 100) +
        stat_data.min[type]
      );
    },
  },
};
</script>
